import React from 'react'
import Notes from '../components/Notes';

const Home = () => {
    return <Notes />
}

export default Home;
